import { format, formatDistance } from 'date-fns'

export const dateToText = (date) =>
  format(new Date(date), 'dd-MMM-yyyy HH:mm:ss')

export const timeAgo = (date) =>
  formatDistance(new Date(date), new Date(), { addSuffix: true })
